module.exports = __webpack_public_path__ + "img/chart-2.223d1327.jpg";